/** Tear down UnifiedMultiSelect menus appended to document.body (avoids stuck overlays). */
export function teardownMultiSelectPortals(root?: ParentNode | null): void {
  const api = (
    window as Window & { UnifiedMultiSelect?: { closeAll: () => void } }
  ).UnifiedMultiSelect;
  api?.closeAll();
  if (root) {
    root.querySelectorAll(".cs.cms").forEach((wrap) => {
      const trigger = wrap.querySelector<HTMLElement>(".cs-trigger");
      const menuId = trigger?.getAttribute("aria-controls");
      if (menuId) document.getElementById(menuId)?.remove();
    });
  }
  document.querySelectorAll("body > ul.cs-menu.cms-menu").forEach((menu) => {
    const id = menu.id;
    if (!id) {
      menu.remove();
      return;
    }
    const trigger = document.querySelector(`[aria-controls="${CSS.escape(id)}"]`);
    if (!trigger || !trigger.isConnected) menu.remove();
  });
}
